module.exports = __webpack_public_path__ + "img/bg.1491e40a.png";